/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import { Action, ActionCreators } from './actions';
import Antenna from '../../shared/entities/antenna';
import { Antennas } from '../../shared/entities/options/antennas';

export interface State {
  readonly antennas: Antennas;
  readonly isRequestingAntennas: boolean;
  readonly isAntennasRequestFinished: boolean;
  readonly requestAntennasError?: string;
}

export const initialAntennasState: State = {
  antennas: undefined,
  isRequestingAntennas: false,
  isAntennasRequestFinished: false,
  requestAntennasError: undefined,
};

export default function reducer(state: State = initialAntennasState, action: Action): State {
  let partialState: Partial<State> | undefined;

  switch (action.type) {
    case ActionCreators.RequestAntennas.type:
      partialState = {
        antennas: undefined,
        isRequestingAntennas: true,
        isAntennasRequestFinished: false,
        requestAntennasError: undefined,
      };
      break;

    case ActionCreators.ReceivedAntennasSuccess.type: {
      const compiledAntennas: Antennas = {};

      action.payload.response.forEach((antenna: Antenna) => {
        compiledAntennas[antenna.id] = antenna;
      });

      partialState = {
        antennas: compiledAntennas,
        isRequestingAntennas: false,
        isAntennasRequestFinished: true,
        requestAntennasError: undefined,
      };
      break;
    }

    case ActionCreators.ReceivedAntennasError.type:
      partialState = {
        isRequestingAntennas: false,
        isAntennasRequestFinished: true,
        requestAntennasError: action.payload.message,
      };
      break;

    default:
      return state;
  }
  return { ...state, ...partialState };
}
